import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import { cssForHeaderWithLinearGradient, cssPropertiesToString } from "@utils";

export const HeaderStyled = styled("div")(
  ({ theme }) => css`
    text-align: center;

    > * {
      ${theme.breakpoints.up("mobile")} {
        margin: 0 16px;
      }

      ${theme.breakpoints.up("tablet")} {
        margin: 0 auto;
        max-width: 640px;
      }

      ${theme.breakpoints.up("desktop")} {
        max-width: 700px;
      }
    }

    > p {
      color: ${getColor(x => x.tokens.text["sub-600"], theme)};

      ${theme.breakpoints.up("mobile")} {
        ${cssPropertiesToString(theme.typography.paragraph_medium_regular)}
      }

      ${theme.breakpoints.up("tablet")} {
        ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
      }

      ${theme.breakpoints.up("desktop")} {
        ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
      }
    }

    h2 {
      ${cssForHeaderWithLinearGradient(theme)}

      ${theme.breakpoints.up("mobile")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_mobile)}
      }

      ${theme.breakpoints.up("tablet")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_tablet)}
      }

      ${theme.breakpoints.up("desktop")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_desktop)}
      }
    }
  `,
);

export const ArticlesFlexContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    padding-top: 16px;
    gap: 24px;

    ${theme.breakpoints.up("mobile")} {
      margin: 0 16px;
      flex-direction: column;
    }

    ${theme.breakpoints.up("tablet")} {
      margin: 0 auto;
      max-width: 640px;
      flex-direction: row;
    }

    ${theme.breakpoints.up("desktop")} {
      max-width: 800px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      max-width: 1000px;
    }
  `,
);
